import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationCancel, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { LoadingAnimationService } from '@/core/services/loading-animation.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from './core/services/i18nService';
import { AnfrageLanguageService } from './core/services/anfrage-language.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent implements OnInit {
  protected navigationEndSubscription: Subscription;

  constructor(protected router: Router,
    protected activatedRoute: ActivatedRoute,
    protected titleService: Title,
    protected loadingAnimationService: LoadingAnimationService,
    public translate: TranslateService,
    public languageService: I18nService,
    protected anfrageLanguageService: AnfrageLanguageService) {

    translate.addLangs(languageService.supportedLanguages);
    translate.setDefaultLang(languageService.defaultLanguage);

    let navigationStart = this.router.events.pipe(filter(event => event instanceof NavigationStart));
    let navigationEnd = this.router.events.pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel));

    navigationStart.subscribe(() => {
      this.navigationEndSubscription = navigationEnd.subscribe(() => { this.navigationEndSubscription.unsubscribe(); });
      const noLoadingSpinner: boolean | null = this.router.currentNavigation()?.extras?.state?.noLoadingSpinner;

      if (noLoadingSpinner !== true) {
        this.loadingAnimationService.showSpinnerUsingSubscription(this.navigationEndSubscription);
      }
    });
  }

  ngOnInit() {
    const onNavigationEnd = this.router.events.pipe(filter(event => event instanceof NavigationEnd));

    // Change page title on navigation or language change, based on route data
    onNavigationEnd.pipe(
      map(() => {
        let route = this.activatedRoute;
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      filter(route => route.outlet === 'primary'),
      mergeMap(route => route.data)
    )
      .subscribe(event => {
          const noScrollTop: boolean | null = this.router.currentNavigation()?.extras?.state?.noScrollTop;

        if (noScrollTop !== true) {
          let topPosition = document.getElementById('topPosition');
  
          if (topPosition)
            topPosition.scrollIntoView()
        }

        const title = event['title'];
        if (title) {
          this.titleService.setTitle(title);
        }
      });
  }

  reconnectBlazor() {
    let windowAny: any = window;
    windowAny.Blazor.reconnect();
  }

  closeBlazorDisconnectScreen() {
    document.getElementById("components-reconnect-modal")?.remove();
  }

  public blazorLibIsLoaded(): boolean {
    let windowAny: any = window;
    return windowAny.Blazor != undefined;
  }
}
